export default __webpack_public_path__ + "static/media/autoconsumo-individual-con-excedentes-compensacion.bdb2ba16.png";